export default function SimulariPage() {
const files = [
  "Raport S-Bac _ Plan de masuri.PDF",
  "Raport S-EN08 _Plan de actiune_ .PDF"
];

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="space-y-2">
          {files.map((file) => (
            <p key={file}>
              <a
                href={`/educatie/simulari/${file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {file}
              </a>
            </p>
          ))}
        </div>

      </main>
    </div>
  );
}